const getters = {
  language: state => state.app.language,
  preViewFile: state=>state.app.preViewFile,
  seeFlag:state=>state.app.seeFlag
}
export default getters
